
import { manHdrStateCheckboxOption } from "presentation/constant/CheckBox/StaticCheckboxOptions";
import { ManualChargeConstant } from "presentation/constant/ManualCharge/ManualChargeConstant";
import { useManualChargeHeaderMaintenanceVM } from "presentation/hook/ManualCharge/useManualChargeHeaderMaintenanceVM";
import { useManualChargeHeaderMaintenanceTracked } from "presentation/store/ManualCharge/ManualChargeHeaderMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { FieldType, GroupCheckboxList, HPHGroupCheckbox, HPHInputMask, IFieldValue } from "veronica-ui-component/dist/component/core";

const ManualChargeHeaderSearchForm = () => {
    const [manualChargeHeaderState] = useManualChargeHeaderMaintenanceTracked();
    const manualChargeHeaderVM = useManualChargeHeaderMaintenanceVM();
    const MAN_CHG_HDR_CONST = ManualChargeConstant.Header;
    const headerSearchCriteria = manualChargeHeaderState.searchCriteria;
    //const enabledCriteria = useMemo(() => ManChargeHdrCriteriaDirectoryCheckboxOption?.find(item => manualChargeHeaderState.enabledSearchCriteria[item.key]), [manualChargeHeaderState.enabledSearchCriteria]);

    const memoCoVslVoy = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: '190px', maxWidth: '410px', width: "100%" }}>
            <HPHInputMask
                label={MAN_CHG_HDR_CONST.CO_VSL_VOY}
                width="100%"
                value={{
                    co: headerSearchCriteria.co ?? '',
                    vsl: headerSearchCriteria.vsl ?? '',
                    voy: headerSearchCriteria.voy ?? ''
                }}
                fieldConfiguration={{
                    co: { maxLength: 4, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    vsl: { maxLength: 6, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    voy: { maxLength: 10, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                }}
                onDataChange={(e: any) => manualChargeHeaderVM.onCoVslVoyChange(e, {
                    co: 'co',
                    vsl: 'vsl',
                    voy: 'voy'
                })} />
        </div>
        , [MAN_CHG_HDR_CONST.CO_VSL_VOY, headerSearchCriteria.co, headerSearchCriteria.vsl, headerSearchCriteria.voy, manualChargeHeaderVM])

    const memoChgType = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: '190px', maxWidth: '410px', width: "100%" }}>

            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={headerSearchCriteria?.chargeTypeList?.join(',')}
                fieldValue={headerSearchCriteria?.chargeTypeList}
                fieldLabel={MAN_CHG_HDR_CONST.CHARGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeTypeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={manualChargeHeaderState.dynamicOptions.chargeTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    manualChargeHeaderVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [MAN_CHG_HDR_CONST.CHARGE_TYPE, headerSearchCriteria.chargeTypeList, manualChargeHeaderState.dynamicOptions.chargeTypeDropdownOptions, manualChargeHeaderVM])

    const memoState = useMemo(() =>
        <div className='im-flex-row-item'>
            <HPHGroupCheckbox
                label={MAN_CHG_HDR_CONST.STATE}
                checkboxData={manHdrStateCheckboxOption}
                selectedValues={headerSearchCriteria.stateList}
                orientation={"horizontal"}
                onChange={(e: (GroupCheckboxList | undefined)[]) => manualChargeHeaderVM.onGroupCheckboxChange(e, headerSearchCriteria, "stateList")}
            />
        </div>
        , [MAN_CHG_HDR_CONST.STATE, headerSearchCriteria, manualChargeHeaderVM])

    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: '190px', maxWidth: '410px', width: "100%" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={headerSearchCriteria?.billToCompList?.join(',')}
                fieldValue={headerSearchCriteria?.billToCompList}
                fieldLabel={MAN_CHG_HDR_CONST.BILL_TO_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={manualChargeHeaderState.dynamicOptions.billToCompDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    manualChargeHeaderVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [MAN_CHG_HDR_CONST.BILL_TO_COMPANY, headerSearchCriteria.billToCompList, manualChargeHeaderState.dynamicOptions.billToCompDropdownOptions, manualChargeHeaderVM])

    const memoOpsDateFromTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: '190px', maxWidth: '410px', width: "100%" }}>
            <DateRangePickerComponent
                label={MAN_CHG_HDR_CONST.OPS_DATE_RANGE}
                width='100%'
                fieldNames={{ startField: "opsDateFrom", endField: "opsDateTo" }}
                dateRange={{ startDate: headerSearchCriteria.opsDateFrom, endDate: headerSearchCriteria.opsDateTo }}
                onDatesChange={manualChargeHeaderVM.onDateRangeChange}
            />
        </div>
        , [MAN_CHG_HDR_CONST.OPS_DATE_RANGE, headerSearchCriteria.opsDateFrom, headerSearchCriteria.opsDateTo, manualChargeHeaderVM.onDateRangeChange])

    const memoCreatedDateFromTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: '190px', maxWidth: '410px', width: "100%" }}>
            <DateRangePickerComponent
                label={MAN_CHG_HDR_CONST.CREATED_DATE_RANGE}
                width='100%'
                fieldNames={{ startField: "createdDateFrom", endField: "createdDateTo" }}
                dateRange={{ startDate: headerSearchCriteria.createdDateFrom, endDate: headerSearchCriteria.createdDateTo }}
                onDatesChange={manualChargeHeaderVM.onDateRangeChange}
            />
        </div>
        , [MAN_CHG_HDR_CONST.CREATED_DATE_RANGE, headerSearchCriteria.createdDateFrom, headerSearchCriteria.createdDateTo, manualChargeHeaderVM.onDateRangeChange])

    const memoRefNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: '190px', maxWidth: '190px', width: "47.5%" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={headerSearchCriteria.refNo || ''}
                fieldValue={headerSearchCriteria.refNo}
                fieldLabel={MAN_CHG_HDR_CONST.REF_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'refNo'}
                maxLength={10}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    manualChargeHeaderVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [MAN_CHG_HDR_CONST.REF_NO, headerSearchCriteria.refNo, manualChargeHeaderVM])

    const memoInvCreditNoteNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: '190px', maxWidth: '190px', width: "47.5%" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={headerSearchCriteria.invCreditNoteNo || ''}
                fieldValue={headerSearchCriteria.invCreditNoteNo}
                fieldLabel={MAN_CHG_HDR_CONST.INV_CR_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'invCreditNoteNo'}
                maxLength={12}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    manualChargeHeaderVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [MAN_CHG_HDR_CONST.INV_CR_NO, headerSearchCriteria.invCreditNoteNo, manualChargeHeaderVM])

    return <>

        <CriteriaItemContainer>
            {manualChargeHeaderState.enabledSearchCriteria.stateList ? memoState : null}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {manualChargeHeaderState.enabledSearchCriteria.chargeTypeList ? memoChgType : null}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {manualChargeHeaderState.enabledSearchCriteria.billToCompList ? memoBillToCompany : null}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {
                //manualChargeHeaderState.enabledSearchCriteria.coVslVoy ? memoConsortiumDropDown : null
            }
            {manualChargeHeaderState.enabledSearchCriteria.coVslVoy ? memoCoVslVoy : null}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {manualChargeHeaderState.enabledSearchCriteria.invCreditNoteNo ? memoInvCreditNoteNo : null}
            {manualChargeHeaderState.enabledSearchCriteria.refNo ? memoRefNo : null}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {manualChargeHeaderState.enabledSearchCriteria.opsDate ? memoOpsDateFromTo : null}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {manualChargeHeaderState.enabledSearchCriteria.createdDate ? memoCreatedDateFromTo : null}
        </CriteriaItemContainer>
    </>;
}
export default memo(ManualChargeHeaderSearchForm);